export default {
    en: "English",
    cy: "Welsh",
  }